import { action } from 'satcheljs';
import type { SearchScenarioId } from '../store/schema/SearchScenarioId';

export interface INITIALIZE_SCENARIO_STOREActionMessage {
    scenarioId: SearchScenarioId;
}
export const initializeScenarioStore: (
    scenarioId: SearchScenarioId
) => INITIALIZE_SCENARIO_STOREActionMessage = action(
    'INITIALIZE_SCENARIO_STORE',
    (scenarioId: SearchScenarioId): INITIALIZE_SCENARIO_STOREActionMessage => ({
        scenarioId,
    })
);
